"use client";
import { Progress } from "@/components/progress";
import { useSilo } from "@/providers/global-data.provider";
import { mainConfig } from "@/configs/main.config";

export function CountryList() {
  const { countries, isLoading } = useSilo();

  // Show loading state
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin h-8 w-8 border-4 border-[#FF8A3C] border-t-transparent rounded-full"></div>
      </div>
    );
  }

  // Show message if no data
  if (!countries || countries.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No country data available
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {countries.map((country, index) => (
        <div key={index} className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="font-medium">{mainConfig.countryCodeToName[country.countryCode] || country.countryCode}</span>
            <span className="text-sm text-muted-foreground">{country.nodes} nodes</span>
          </div>
          <Progress value={country.percentage} className="h-2" indicatorClassName="bg-[#FF8A3C]" />
        </div>
      ))}
    </div>
  );
}
